import { config } from './config';
import { stableStringify } from './stableStringify';
import { createDPoPProof } from '../services/dpop';
import type { MintContext } from './mint';

export async function submitToMailer(
  formData: Record<string, string>,
  token: string | undefined,
  mintContext: MintContext
): Promise<Response> {
  const body = stableStringify(formData);

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const options: RequestInit = { method: 'POST', headers, body };

  if (config.mode === 'cookie') {
    options.credentials = 'include';
  } else if (config.mode === 'dpop') {
    if (!token || !mintContext.keypair || !mintContext.publicJwk) {
      throw new Error('DPoP mode requires token and keypair from mint');
    }
    const proof = await createDPoPProof(mintContext.keypair.privateKey, mintContext.publicJwk as any, 'POST', config.mailerUrl);
    headers['Authorization'] = `Bearer ${token}`;
    headers['DPoP'] = proof;
  }

  let res: Response;
  try {
    res = await fetch(config.mailerUrl, options);
  } catch (_e) {
    throw new Error('Unable to send your message. Please check your internet connection and try again.');
  }
  return res;
}


